import { articleCategoryService } from '@/services/api/articleCategory.service';
import { articleCategoryModel } from '@/models/api/articleCategory.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const ARTICLE_CATEGORY_MODULE = 'api/articleCategory';
export const GET_ALL_ARTICLE_CATEGORY = 'getAllArticleCategory';
export const CREATE_ARTICLE_CATEGORY = 'createArticleCategory';
export const GET_ARTICLE_CATEGORY = 'getArticleCategory';
export const UPDATE_ARTICLE_CATEGORY = 'updateArticleCategory';
export const DELETE_ARTICLE_CATEGORY = 'deleteArticleCategory';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 1,
            pageSize: 15,
            lastPage: 1,
            tableRowsCounts: 0,
            total: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true
    },
};

export const actions = {
    async [GET_ALL_ARTICLE_CATEGORY]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await articleCategoryService.getAll(filter);
            commit('listSuccess', result);
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [CREATE_ARTICLE_CATEGORY]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await articleCategoryService.store(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.createXSuccess', [i18n.t('module.articleCategory')]) });
            await dispatch(GET_ALL_ARTICLE_CATEGORY, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [GET_ARTICLE_CATEGORY]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await articleCategoryService.show(uuid);
            commit('detailSuccess', result);
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [UPDATE_ARTICLE_CATEGORY]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await articleCategoryService.update(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.articleCategory')]) });
            await dispatch(GET_ALL_ARTICLE_CATEGORY, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [DELETE_ARTICLE_CATEGORY]({ commit, dispatch }, { uuid, filter }) {
        commit('requesting', 'save');
        try {
            const result = await articleCategoryService.softDelete(uuid);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.deleteXSuccess', [i18n.t('module.articleCategory')]) });
            await dispatch(GET_ALL_ARTICLE_CATEGORY, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type = 'list') {
        state.status[type] = false;
    },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(articleCategoryModel);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
        state.status.list = true;
    },
    detailSuccess(state, result) {
        const payload = result?.data || {};
        state.details = articleCategoryModel(payload);
        state.status.detail = true;
    },
    success(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
    failure(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
};
